import {IReducersMap, reducer} from '../../standard-actions/reducers'
import {
  SERVICE_PERFORMANCE_LOAD_SERVICES,
  SERVICE_PERFORMANCE_LOAD_TIME_RANGES,
  SERVICE_PERFORMANCE_LOAD_SITES,
  SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL,
  SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_INT,
  SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_GRAPH,
  SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA,
  SERVICE_PERFORMANCE_LOAD_SITE_SERVICES,
  SERVICE_PERFORMANCE_LOAD_SITES_SUMMARY,
  SERVICE_PERFORMANCE_PUT_REFERENCE,
  SERVICE_PERFORMANCE_LOAD_SERVICE_FILTERS,
  SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE,
  INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SERVICE,
  SERVICE_PERFORMANCE_LOAD_SERVICES_INT,
  YOUR_SERVICES_INT_DOWNLOAD_CSV,
  SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT,
  SERVICE_PERFORMANCE_LOAD_SERVICES_AUTO_INT,
  SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT,
  INVENTORY_INTERNATIONAL_UPDATE_FILTER_COMPANIES,
  INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SITES,
  INVENTORY_INTERNATIONAL_UPDATE_COMBINE_TAGS_SERVICE,
  SERVICE_PERFORMANCE_LOAD_SERVICES_SUMMARY,
  USER_MANAGEMENT_GET_USER_DYNAMIC,
  SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_INT_BY_CIDN,
  SERVICE_PERFORMANCE_LOAD_IP_SERVICES_INT,
  SERVICE_PERFORMANCE_DELETE_PREFIX_SERVICES_INT,
  NETWORK_PREFIX_SERVICES_INT_DOWNLOAD_CSV,
  SERVICE_PERFORMANCE_SUBMIT_PREFIX_SERVICES_INT,
  SERVICE_PERFORMANCE_VALIDATE_PREFIX_SERVICE_INT,
  SERVICE_PERFORMANCE_LOAD_COMPANY,
  LOAD_NETWORK_PERFORMANCE_REPORTS,
  LOAD_NP_REPORTS_URL,
  SERVICE_AS_SET_OBJECT,
  SERVICE_PERFORMANCE_LOAD_DNS_SERVICES_INT,
  SERVICE_PERFORMANCE_DELETE_DNS_SERVICES_INT,
  REVERSE_DNS_SERVICES_INT_DOWNLOAD_CSV,
  SERVICE_PERFORMANCE_SUBMIT_DNS_SERVICES_INT,
  SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT,
  SERVICE_LOAD_SERVICE_LIST_FILTER_INT,
  INVENTORY_INTERNATIONAL_UPDATE_GROUP_BY_SERVICE,
  UPDATE_SERVICES_USER_REFERENCE,
} from '../actions/action-types'

import {IServicePerformanceState} from '../state'
import {initialState} from '../state/initial-state'
import {loadServicesReducer, LoadServicesAction} from './load-services'
import {loadTimeRangesReducer, LoadTimeRangesAction} from './load-time-ranges'
import {loadSitesReducer, LoadSitesAction} from './load-sites'
import {loadServiceDetailReducer, LoadServiceDetailAction} from './load-service-detail'
import {loadServiceDetailReducerInt, LoadServiceDetailActionInt} from './load-service-detail-int'
import {
  loadServiceDetailGraphReducer,
  LoadServiceDetailGraphAction,
} from './load-service-detail-graph-data'
import {loadSitesMapDataReducer, LoadSitesMapDataAction} from './load-sites-map-data'
import {loadSiteServicesReducer, LoadSiteServicesAction} from './load-site-services'
import {loadSitesSummaryReducer, LoadSitesSummaryAction} from './load-sites-summary'
import {putReferenceReducer, PutReferenceAction} from './put-reference'
import {loadServiceFiltersReducer, LoadServiceFiltersAction} from './load-service-filters'
import {putServiceReferenceReducer, PutServiceReferenceAction} from './put-service-reference'
import {
  updateCombineTagsSuccessReducer,
  updateCompaniesSuccessReducer,
  updateServicesSuccessReducer,
  updateSitesCompaniesSuccessReducer,
} from './load-search-services-int'
import {loadServicesIntReducer, LoadServicesActionInt} from './load-services-int'
import {downloadFileIntReducer} from './download-export-int'
import {
  PutServiceReferenceIntAction,
  putServiceReferenceIntReducer,
  putServiceReferenceServiceIdReducer,
} from './put-service-reference-int'
import {LoadServicesActionAutoInt, loadServicesIntAutoReducer} from './load-services-int-auto'
import {LoadServicesSummaryAction, loadServicesSummaryReducer} from './load-services-summary'
import {GetUserDynamicReducer, GetUserDynamicAction} from './user-dynamic-reducer'
import {loadServiceDetailReducerIntByCidn} from './load-service-detail-int-by-selected-cidn'
import {loadIPServicesReducerInt} from './load-ip-services-int'
import {
  loadServicesListReducerInt,
  LoadServicesListFilterInt,
} from './load-services-list-filter-int'
import {deletePrefixServicesReducerInt} from './delete-prefix-services-int'
import {deleteDnsServicesReducerInt} from './delete-dns-services-int'
import {exportNetworkPrefixListIntReducer} from './export-network-prefix-list-int'
import {exportReverseDnsIntReducer} from './export-reverse-dns-list-int'
import {submitPrefixServicesReducerInt} from './submit-prefix-services-int'
import {validatePrefixServiceReducer} from './validate-prefix-service'
import {loadCompanyDataReducerInt} from './load-company-data'
import {loadNetworkPerformanceReportsReducer} from './load-network-performance-reports'
import {loadNpReportsUrlReducer} from './load-np-reports-url'
import {LoadAsSetObjectActionInt, loadAsSetObjectIntReducer} from './load-as-set-object-int'
import {loadDnsServicesReducerInt} from './load-dns-services-int'
import {submitDnsServicesReducerInt} from './submit-reverse-dns-int'
import {loadServiceTypesReducerInt, LoadServiceTypesActionInt} from './load-service-types-int'
import {updateServicesSuccessGroupByReducer} from './load-group-by-services-int'
import {
  updateServicesReferenceReducerInt,
  UpdateServiceswithReferencetInt,
} from './update-services-withr-reference-int'

export type ServicePerformanceAction =
  | LoadServicesAction
  | LoadTimeRangesAction
  | LoadSitesAction
  | LoadSitesMapDataAction
  | LoadServiceDetailAction
  | LoadServiceDetailActionInt
  | LoadServiceDetailGraphAction
  | LoadSiteServicesAction
  | LoadSitesSummaryAction
  | PutReferenceAction
  | LoadServiceFiltersAction
  | PutServiceReferenceAction
  | LoadServicesActionInt
  | PutServiceReferenceIntAction
  | LoadServicesActionAutoInt
  | LoadServicesSummaryAction
  | GetUserDynamicAction
  | LoadAsSetObjectActionInt
  | LoadServiceTypesActionInt
  | LoadServicesListFilterInt
  | UpdateServiceswithReferencetInt

const reducersMap: IReducersMap<IServicePerformanceState> = {
  [SERVICE_PERFORMANCE_LOAD_SERVICES]: loadServicesReducer,
  [SERVICE_PERFORMANCE_LOAD_SERVICES_INT]: loadServicesIntReducer,
  [SERVICE_PERFORMANCE_LOAD_TIME_RANGES]: loadTimeRangesReducer,
  [SERVICE_PERFORMANCE_LOAD_SITES]: loadSitesReducer,
  [SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL]: loadServiceDetailReducer,
  [SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_INT]: loadServiceDetailReducerInt,
  [SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_GRAPH]: loadServiceDetailGraphReducer,
  [SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA]: loadSitesMapDataReducer,
  [SERVICE_PERFORMANCE_LOAD_SITE_SERVICES]: loadSiteServicesReducer,
  [SERVICE_PERFORMANCE_LOAD_SITES_SUMMARY]: loadSitesSummaryReducer,
  [SERVICE_PERFORMANCE_LOAD_SERVICES_SUMMARY]: loadServicesSummaryReducer,
  [SERVICE_PERFORMANCE_PUT_REFERENCE]: putReferenceReducer,
  [SERVICE_PERFORMANCE_LOAD_SERVICE_FILTERS]: loadServiceFiltersReducer,
  [SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE]: putServiceReferenceReducer,
  [INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SERVICE]: updateServicesSuccessReducer,
  [YOUR_SERVICES_INT_DOWNLOAD_CSV]: downloadFileIntReducer,
  [SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT]: putServiceReferenceIntReducer,
  [SERVICE_PERFORMANCE_LOAD_SERVICES_AUTO_INT]: loadServicesIntAutoReducer,
  [SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT]: putServiceReferenceServiceIdReducer,
  [INVENTORY_INTERNATIONAL_UPDATE_FILTER_COMPANIES]: updateCompaniesSuccessReducer,
  [INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SITES]: updateSitesCompaniesSuccessReducer,
  [INVENTORY_INTERNATIONAL_UPDATE_COMBINE_TAGS_SERVICE]: updateCombineTagsSuccessReducer,
  [USER_MANAGEMENT_GET_USER_DYNAMIC]: GetUserDynamicReducer,
  [SERVICE_PERFORMANCE_LOAD_SERVICE_DETAIL_INT_BY_CIDN]: loadServiceDetailReducerIntByCidn,
  [SERVICE_PERFORMANCE_LOAD_IP_SERVICES_INT]: loadIPServicesReducerInt,
  [SERVICE_PERFORMANCE_DELETE_PREFIX_SERVICES_INT]: deletePrefixServicesReducerInt,
  [SERVICE_PERFORMANCE_DELETE_DNS_SERVICES_INT]: deleteDnsServicesReducerInt,
  [NETWORK_PREFIX_SERVICES_INT_DOWNLOAD_CSV]: exportNetworkPrefixListIntReducer,
  [SERVICE_PERFORMANCE_SUBMIT_PREFIX_SERVICES_INT]: submitPrefixServicesReducerInt,
  [SERVICE_PERFORMANCE_VALIDATE_PREFIX_SERVICE_INT]: validatePrefixServiceReducer,
  [SERVICE_PERFORMANCE_LOAD_COMPANY]: loadCompanyDataReducerInt,
  [LOAD_NETWORK_PERFORMANCE_REPORTS]: loadNetworkPerformanceReportsReducer,
  [LOAD_NP_REPORTS_URL]: loadNpReportsUrlReducer,
  [SERVICE_AS_SET_OBJECT]: loadAsSetObjectIntReducer,
  [SERVICE_PERFORMANCE_LOAD_DNS_SERVICES_INT]: loadDnsServicesReducerInt,
  [REVERSE_DNS_SERVICES_INT_DOWNLOAD_CSV]: exportReverseDnsIntReducer,
  [SERVICE_PERFORMANCE_SUBMIT_DNS_SERVICES_INT]: submitDnsServicesReducerInt,
  [SERVICE_PERFORMANCE_LOAD_SERVICE_TYPES_INT]: loadServiceTypesReducerInt,
  [SERVICE_LOAD_SERVICE_LIST_FILTER_INT]: loadServicesListReducerInt,
  [INVENTORY_INTERNATIONAL_UPDATE_GROUP_BY_SERVICE]: updateServicesSuccessGroupByReducer,
  [UPDATE_SERVICES_USER_REFERENCE]: updateServicesReferenceReducerInt,
}

export const performanceReducer = reducer<IServicePerformanceState, ServicePerformanceAction>(
  reducersMap,
  initialState,
)
